module.exports = __webpack_public_path__ + "img/shou_icon2.18816327.png";